export default __webpack_public_path__ + "static/daemons-c1de844adfe04cf778f3314b7a45d029.webp";